export const SUBSCRIPTION_ID_ATTRIBUTE = "data-subscription-id";
